import React, { useState, useRef, useEffect } from "react"
import { Link, useNavigate, useParams } from "react-router-dom"
import {
  addVisit,
  getStream,
  getRecord,
  getRefferedby,
  getVisitType,
  getPatient,
  getVisit,
  getPatientbyclinicid,
  getPatientsByClinicId,
  getOnePatient,
  getClinic,
  getVisitCountByPatientId,
  getPatientByMpino,
} from "../../service/api"
import { toast } from "react-toastify"
import Select from 'react-select';

import "flatpickr/dist/themes/material_blue.css"

import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  CardTitle,
  Label,
  Button,
  Form,
  Input,
  InputGroup,
  Table,
} from "reactstrap"
import { jwtDecode } from "jwt-decode";


const defaultValue = {
  mpi: "",
  totalvisit: "",
  visit_no: "",
  patientid: "",
  title: "",
  firstname: "",
  lastname: "",
  age: "",
  address: "",
  clinicmobile: "",
  email: "",
  stream: "",
  category: "",
  visitType: "",
  referred: "",
  visit_no: '',
}

const cardTopStyle = {
  backgroundColor: "#DC4C64",
  padding: "4px",
  color: "white",
  height: "30px",
}

const Addvisit = () => {
  const [visit, setVisit] = useState(defaultValue)
  const [patients, setPatients] = useState([]);
  const [loader, setLoader] = useState(false);
  const { id } = useParams();
  const onValueChange = e => {
    if (e && e.target) {
      setVisit({ ...visit, [e.target.name]: e.target.value })
    }
    console.log(visit)
  }

  const [str, setStr] = useState([])
  const [record, setRecord] = useState([])
  const [refe, setRefe] = useState([])
  const [visitType, setVisitType] = useState([])
  const [loading, setLoading] = useState(false);
  const [allcliniclist, setallclinic] = useState([]);
  const [clinicIdFromToken, setClinicIdFromToken] = useState(null);

  const [Visits, setVisits] = useState([])
  const navigate = useNavigate();
  useEffect(() => {
    getStreamData(), getRecordData(), getRefferedData(), getVisitTypeData(), getPatientAll(), getallVisit();
  }, [])

  const getStreamData = async () => {
    let response = await getStream()
    setStr(response.data)
  }

  const getRecordData = async () => {
    let RecData = await getRecord()
    setRecord(RecData.data)
  }

  const getRefferedData = async () => {
    let refData = await getRefferedby()
    setRefe(refData.data)
  }

  const getVisitTypeData = async () => {
    let refData1 = await getVisitType()
    setVisitType(refData1.data)
  }

  const getPatientAll = async () => {
    try {
      const token = localStorage.getItem("token");
      let response;

      if (token) {
        const decoded = jwtDecode(token);
        const clinicID = decoded?.clinicID;
        setClinicIdFromToken(clinicID || null);

        response = clinicID
          ? await getPatientsByClinicId(clinicID)
          : await getPatient();

        // ✅ Handle both response structures
        if (Array.isArray(response?.data)) {
          setPatients(response.data);
        } else if (Array.isArray(response?.data?.data)) {
          setPatients(response.data.data);
        } else {
          setPatients([]);
        }
      }
    } catch (error) {
      console.log("Error while fetching patient data:", error);
      setPatients([]);
    } finally {
      setLoading(false);
    }
  };

  const handleClinicChange = async (e) => {
    const clinicId = e.target.value;

    setVisit(prev => ({
      ...prev,
      clinicname: clinicId,
      mpino: "",
      patientid: "",
      totalvisit: ""
    }));

    if (clinicId) {
      const response = await getPatientsByClinicId(clinicId);

      // 🔹 set patients list
      const patientList = normalizePatients(response);
      setPatients(patientList);

      // 🔹 set visit count directly from API
      const visitCount = response?.data?.count ?? 0;

      setVisit(prev => ({
        ...prev,
        totalvisit: visitCount
      }));

    }
  };
  const normalizePatients = (res) => {
    if (Array.isArray(res)) return res;
    if (Array.isArray(res?.data)) return res.data;
    if (Array.isArray(res?.data?.data)) return res.data.data;
    return [];
  };


  useEffect(() => {
    if (id) {
      fetchPatientById(id);
    }
    getallclinic()
  }, [id]);

  useEffect(() => {
    const setClinicVisitCountOnLoad = async () => {
      if (!clinicIdFromToken || id) return; // ❌ skip edit mode

      try {
        // 🔹 auto set clinic in form
        setVisit(prev => ({
          ...prev,
          clinicname: clinicIdFromToken,
        }));

        // 🔹 fetch patients + count
        const response = await getPatientsByClinicId(clinicIdFromToken);

        const patientList = normalizePatients(response);
        setPatients(patientList);

        // 🔹 set total visit count
        const visitCount = response?.data?.count ?? 0;

        setVisit(prev => ({
          ...prev,
          totalvisit: visitCount,
        }));

      } catch (err) {
        console.error("Error auto loading clinic visit count", err);
        setVisit(prev => ({
          ...prev,
          totalvisit: 0,
        }));
      }
    };

    setClinicVisitCountOnLoad();
  }, [clinicIdFromToken]);


  const getallclinic = async () => {
    try {
      let response;
      response = await getClinic();
      setallclinic(response.data);
    } catch (err) {
      console.error("Error fetching clinic(s)", err);
    }
  };

  const fetchPatientById = async (patientId) => {
    try {
      const response = await getOnePatient(patientId);
      const patient = response.data;

      if (patient) {
        // sQuantityUnit is populated (object) by getOnePatient but plain ID by getPatientByMpino.
        // Always extract the _id so the Classification <select> value matches option values.
        const streamId = patient.sQuantityUnit?._id || patient.sQuantityUnit || "";

        setVisit(prev => ({
          ...prev,
          mpino: patient.mpino,
          patientid: patient._id,
          title: patient.title || "",
          firstname: patient.firstname || "",
          lastname: patient.lastname || "",
          age: patient.age || "",
          address: patient.address || "",
          clinicmobile: patient.mobile || "",
          email: patient.email || "",
          clinicname: patient.clinicname?.name || "",
          stream: streamId,
        }));
        fetchTotalVisits(patient._id);
      }
    } catch (error) {
      console.error("Error fetching patient by ID:", error);
    }
  };


  const getallVisit = async () => {
    let response = await getVisit();
    setVisits(response.data);
  }


  const handleSubmit = async (e) => {
    e.preventDefault()
    setLoader(true);
    try {
      const response = await addVisit(visit);
      const { visit_no } = response.data;
      toast.success(
        ({ closeToast }) => (
          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
            <span>Visit saved successfully. Visit No: {visit_no}</span>
            <button
              onClick={() => {
                navigator.clipboard.writeText(visit_no);
                toast.success("Visit No copied!", { autoClose: 1000 });
              }}
              style={{
                backgroundColor: "transparent",
                color: "#28a745",
                border: "none",
                padding: "5px",
                fontSize: "1.2rem",
                cursor: "pointer",
              }}
              title="Copy Visit No"
            >
              📋
            </button>

          </div>
        ),
        {
          position: "top-center",
          autoClose: 4500,
          closeOnClick: false,
          draggable: false,
        }
      );
      setTimeout(() => {
        navigate("/visit");
      }, 2500);

      console.log("Visit saved successfully:", visit_no);
    } catch (error) {
      toast.error("Failed to save visit.", {
        position: "top-center",
        autoClose: 1500,
      });
      console.error("Error saving visit:", error);
    } finally {
      setLoader(false); // Hide loader
    }
  }

  const handlempiChange = async (selectedOption) => {
    try {
      const response = await getPatientByMpino(selectedOption.value);
      const selectedPatient = response?.data;
      if (selectedPatient) {
        setVisit({
          ...visit,
          mpino: selectedPatient.mpino,
          patientid: selectedPatient._id,
          title: selectedPatient.title || "",
          firstname: selectedPatient.firstname || "",
          lastname: selectedPatient.lastname || "",
          age: selectedPatient.age || "",
          address: selectedPatient.address || "",
          clinicmobile: selectedPatient.mobile || "",
          email: selectedPatient.email || "",
          clinicname: selectedPatient.clinicname?.name || "",
          count: selectedPatient.count || "",
          stream: selectedPatient.sQuantityUnit || "",
        });

        fetchTotalVisits(selectedPatient._id);
      }
    } catch (error) {
      console.error("Error fetching patient by MPI:", error);
    }
  };

  const fetchTotalVisits = async (patientId) => {
    if (!patientId) return;

    try {
      const res = await getVisitCountByPatientId(patientId);
      const count = res?.data?.totalVisits ?? 0;

      setVisit(prev => ({
        ...prev,
        totalvisit: count
      }));
    } catch (error) {
      console.error("Error fetching visit count:", error);
      setVisit(prev => ({
        ...prev,
        totalvisit: 0
      }));
    }
  };


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h4 className="page-title">Visit Registration</h4>
            <Link to="/visit" className="btn btn-danger">
              List
            </Link>
          </div>
          <Row>
            <Card>
              <CardBody>
                <Form>
                  <Row>
                    {!clinicIdFromToken && !id && (
                      <Col md={3}>
                        <div className="mb-3">
                          <Label>Practice Name</Label>
                          <select
                            name="clinicname"
                            className="form-control"
                            value={visit.clinicname || ""}
                            onChange={handleClinicChange}
                          >
                            <option value="">Choose...</option>
                            {allcliniclist.map((clinic) => (
                              <option key={clinic._id} value={clinic._id}>
                                {clinic.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </Col>
                    )}

                    {(clinicIdFromToken || visit.clinicname || id) && (
                      <Col md={3}>
                        <div className="mb-3">
                          <Label>Master Patient Index</Label>

                          {id ? (
                            <Input
                              type="text"
                              className="form-control"
                              name="mpino"
                              value={visit.mpino}
                              readOnly
                            />
                          ) : (
                            <Select
                              value={
                                visit.mpino
                                  ? { label: visit.mpino, value: visit.mpino }
                                  : null
                              }
                              options={patients.map(patient => ({
                                value: patient.mpino,
                                label: patient.mpino,
                              }))}
                              onChange={handlempiChange}
                              name="mpino"
                            />
                          )}
                        </div>
                      </Col>
                    )}
                    <Input
                      type="text"
                      className="form-control"
                      name="patientid"
                      value={visit.patientid}
                      onChange={e => onValueChange(e)}
                      readOnly
                      hidden
                    />
                    <Col md={3}>
                      <div className="mb-3">
                        <Label htmlFor="formrow-country-Input">
                          Total Visits :
                        </Label>
                        <Input
                          type="text"
                          readOnly
                          className="form-control"
                          name="totalvisit"
                          value={visit.totalvisit || 0}
                          placeholder="Total Visits"
                        />

                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={6}>
                      <div style={cardTopStyle}>
                        <CardTitle className="mb-4">Patient Details</CardTitle>
                      </div>
                      <Row>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">Title</Label>
                            <Input
                              type="text"
                              readOnly
                              className="form-control"
                              name="title"
                              value={visit.title}
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">
                              First Name
                            </Label>
                            <Input
                              type="text"
                              readOnly
                              className="form-control"
                              name="firstname"
                              value={visit.firstname}
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">
                              Last Name
                            </Label>
                            <Input
                              type="text"
                              readOnly
                              className="form-control"
                              name="lastname"
                              value={visit.lastname}
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>

                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">Age</Label>
                            <Input
                              type="text"
                              readOnly
                              className="form-control"
                              name="age"
                              value={visit.age}
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">
                              Address
                            </Label>
                            <Input
                              type="textarea"
                              readOnly
                              className="form-control"
                              name="address"
                              value={visit.address}
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">
                              Patient Contact No.
                            </Label>
                            <Input
                              type="text"
                              readOnly
                              className="form-control"
                              name="clinicmobile"
                              value={visit.clinicmobile}
                              placeholder="E.g - 27843938590"
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-country-Input">Email</Label>
                            <Input
                              type="email"
                              readOnly
                              className="form-control"
                              name="email"
                              value={visit.email}
                              onChange={e => onValueChange(e)}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                    <Col md={6}>
                      <div style={cardTopStyle}>
                        <CardTitle className="mb-4">
                          Stream Allocation
                        </CardTitle>
                      </div>
                      <Row>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-login">Classification</Label>
                            <select
                              name="stream"
                              className="form-control"
                              value={visit.stream || ""}
                              onChange={e => onValueChange(e)}
                            >
                              {str.length > 0 ? (
                                <>
                                  <option defaultValue>Select</option>
                                  {str.map(s => (
                                    <option key={s._id} value={s._id}>
                                      {s.name}
                                    </option>
                                  ))}
                                </>
                              ) : (
                                <option disabled>No streams available</option>
                              )}
                            </select>
                          </div>
                        </Col>
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-login">
                              Record Category
                            </Label>
                            <select
                              name="category"
                              className="form-control"
                              onChange={e => onValueChange(e)}
                            >
                              {record.length > 0 ? (
                                <>
                                  <option defaultValue>Select</option>
                                  {record.map(rec => (
                                    <option key={rec._id} value={rec.name}>
                                      {rec.name}
                                    </option>
                                  ))}
                                </>
                              ) : (
                                <option disabled>No streams available</option>
                              )}
                            </select>
                          </div>
                        </Col>
                        {/* <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-login">Visit Type</Label>
                            <select
                              name="visitType"
                              className="form-control"
                              onChange={e => onValueChange(e)}
                            >
                              {visitType.length > 0 ? (
                                <>
                                  <option defaultValue>Select</option>
                                  {visitType.map(vt => (
                                    <option key={vt._id} value={vt.name}>
                                      {vt.name}
                                    </option>
                                  ))}
                                </>
                              ) : (
                                <option disabled>No streams available</option>
                              )}
                            </select>
                          </div>
                        </Col> */}
                        <Col md={6}>
                          <div className="mb-3">
                            <Label htmlFor="formrow-login">Referred By</Label>
                            <select
                              name="referred"
                              className="form-control"
                              onChange={e => onValueChange(e)}
                            >
                              {refe.length > 0 ? (
                                <>
                                  <option defaultValue>Select</option>
                                  {refe.map(rf => (
                                    <option key={rf._id} value={rf.name}>
                                      {rf.name}
                                    </option>
                                  ))}
                                </>
                              ) : (
                                <option disabled>No streams available</option>
                              )}
                            </select>
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <div>
                    <button
                      className="btn btn-primary w-md mx-2"
                      onClick={handleSubmit}
                      disabled={loader}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Saving...
                        </>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>

                  {/* <div>
                    <button
                      className="btn btn-primary w-md mx-2"
                      onClick={e => handleSubmit(e)}
                    >
                      Save
                    </button>
                  </div> */}
                </Form>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Addvisit
